import styled, { keyframes } from 'styled-components';
var rotate = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var Loader = styled.div.withConfig({
  displayName: "LoadingSpinnerstyles__Loader",
  componentId: "pantheon__hhin4s-0"
})(["display:inline-block;position:relative;width:80px;height:80px;& div{box-sizing:border-box;display:block;position:absolute;width:64px;height:64px;margin:8px;border:8px solid ", ";border-radius:50%;animation:", " 1.2s cubic-bezier(0.5,0,0.5,1) infinite;border-color:", " transparent transparent transparent;}& div:nth-of-type(1){animation-delay:-0.45s;}& div:nth-of-type(2){animation-delay:-0.3s;}& div:nth-of-type(3){animation-delay:-0.15s;}"], function (props) {
  return props.color || "#C0C0C0";
}, rotate, function (props) {
  return props.color || "#C0C0C0";
});
export { Loader };